export default __webpack_public_path__ + "static/media/Eye_2_M_C4.d625ab9a.svg";